export const freemiumOnboardingKeys = {
  freemium_onboarding: () => ['FREEMIUM_ONBOARDING'] as const,
};
